import React, { Component } from 'react';
import { authHeader } from '../../components/auth-header';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { AppBar, Toolbar } from '@material-ui/core'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControl from '@material-ui/core/FormControl';
import { userService } from '../../services/user.service';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withSnackbar } from 'material-ui-snackbar-provider'

const minWidthFcStyle = {
    minWidth: 182
};

const divStyle = {
    marginBottom: '20px',
    padding: ' 10px'
};

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

class CalvingReport extends Component {
    static displayName = CalvingReport.name;

    constructor(props) {
        super(props);
        var compo = this;
        var today = new Date();
        var dateFromDefault = today.getFullYear().toString() + "-" + ('0' + (today.getMonth() + 1)).slice(-2).toString() + "-" + ('0' + today.getDate()).slice(-2).toString();
        var dateToDefault = today.getFullYear().toString() + "-" + ('0' + (today.getMonth() + 1)).slice(-2).toString() + "-" + ('0' + today.getDate()).slice(-2).toString();

        this.state = {
            inseminations: [], animals: [], breedings: [], loading: true, loadingInseminations: false, tabId: 0, dateFrom: dateFromDefault, dateTo: dateToDefault, breeding: '0'
        };
        this.save = this.save.bind(this);
        this.generateCalvingResult = this.generateCalvingResult.bind(this);
        this.renderInseminations = this.renderInseminations.bind(this);
        this.renderBusyIndicator = this.renderBusyIndicator.bind(this);

        fetch('api/Animal/Breedings', { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                if (Array.isArray(data)) {
                    localStorage.setItem('breedings', JSON.stringify(data));
                    compo.setState({ breedings: data, loading: false });
                } else {
                    userService.logout();
                    this.props.history.push("/");
                }

            }).catch(function () {
                compo.setState({ breedings: JSON.parse(localStorage.getItem("breedings") ? localStorage.getItem("breedings") : "[]"), loading: false });
                console.log("request failed, fetching data from storage");
            });

    }

    generateCalvingResult(insemination) {
        return insemination;
    }

    save() {
        var comp = this;
        var calvingReports = [];
        //get all inseminations with populated result codes
        for (var i = 0; i < this.state.inseminations.length; i++) {
            //if there is calving status report filled add / edit in calvingreports 
            if (this.state.inseminations[i].calvingResult) {
                calvingReports.push(this.state.inseminations[i]);
            }
        }
        if (calvingReports.length === 0) {
            comp.props.snackbar.showMessage("Nezvolili ste žiadne kódy otelenia")
            return false;
        }

        fetch('api/Insemination/PostInseminations', {
            headers: { 'Content-Type': 'application/json', 'Authorization': authHeader().Authorization },
            method: 'post',
            body: JSON.stringify(calvingReports)
        })
            .then(response => response.json())
            .then(data => {
                comp.storeCavingReports(data);
                comp.props.snackbar.showMessage("Kódy teľnosti pre zvolené inseminácie boli uložené.");

                comp.props.history.push("/insemination-list");
            }).catch(function (err) {
                comp.storeCavingReports(calvingReports);
                comp.props.snackbar.showMessage("Kódy teľnosti pre zvolené inseminácie boli uložené lokálne.");

                comp.props.history.push("/insemination-list");
            });

        return false;
    }

    storeCavingReports(calvingReportsToStore) {
        var calvingReports = JSON.parse(localStorage.getItem("calvingReports") ? localStorage.getItem("calvingReports") : "[]");

        for (var i = 0; i < calvingReportsToStore.length; i++) {
            //handling new/edit
            if (calvingReports.filter(calvingReportstoFilter, i)) {
                calvingReports = calvingReports.filter(filterCalvingReports, i);
            }
            calvingReports.push(calvingReportsToStore[i]);
        }

        localStorage.setItem("calvingReports", JSON.stringify(calvingReports));

        function calvingReportstoFilter(ins) {
            var i = this;
            return ins.id ? (ins.id === calvingReportsToStore[i].id) : (ins.animalCode === calvingReportsToStore[i].animalCode && ins.dateInsem === calvingReportsToStore[i].dateInsem)
        }

        function filterCalvingReports(ins) {
            var i = this;
            return calvingReportsToStore[i].id ? (ins.id !== calvingReportsToStore[i].id) : (ins.animalCode !== calvingReportsToStore[i].animalCode || ins.dateInsem !== calvingReportsToStore[i].dateInsem)
        }
    }

    filter() {
        this.setState({ loadingInseminations: true });
        var compo = this;
        var params = this.state.tabId === 0 ? 'breeding=' + this.state.breeding + '&from=' + this.state.dateFrom + '&to=' + this.state.dateTo : 'animalCode=' + this.state.animalCode + '&breeding=' + this.state.breeding;

        fetch('api/Insemination/Inseminations?' + params, { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                var viewData = data;
                if (compo.state.tabId === 0) {
                    viewData = viewData.filter(ins => new Date(ins.dateInsem.replace(/\s/g, "")) >= new Date(compo.state.dateFrom) && new Date(ins.dateInsem.replace(/\s/g, "")) <= new Date(compo.state.dateTo));
                }
                if (viewData.length === 0) {
                    compo.props.snackbar.showMessage("Nenašli sa žiadne inseminácie k doplneniu.");
                }

                compo.setState({ inseminations: viewData, loadingInseminations: false });
                //get current inseminations for calvingreport
                var currentCalvingReportInseminations = localStorage.getItem('calvingReportInseminations') && Array.isArray(JSON.parse(localStorage.getItem('calvingReportInseminations'))) ? JSON.parse(localStorage.getItem('calvingReportInseminations')) : [];
                //replace breeding list with fresh :) animals
                currentCalvingReportInseminations = currentCalvingReportInseminations.filter(calvList => calvList.breeding !== compo.state.breeding);
                currentCalvingReportInseminations.push({ breeding: compo.state.breeding, inseminations: data });

                localStorage.setItem('calvingReportInseminations', JSON.stringify(currentCalvingReportInseminations))
            }).catch(function () {
                if (localStorage.getItem("calvingReportInseminations") && JSON.parse(localStorage.getItem('calvingReportInseminations')).filter(calvList => calvList.breeding === compo.state.breeding).length > 0) {
                    compo.setState({ inseminations: JSON.parse(localStorage.getItem('calvingReportInseminations')).filter(calvList => calvList.breeding === compo.state.breeding)[0].inseminations.filter(ins => new Date(ins.dateInsem.replace(/\s/g, "")) >= new Date(compo.state.dateFrom) && new Date(ins.dateInsem.replace(/\s/g, "")) <= new Date(compo.state.dateTo)), loadingInseminations: false });
                } else {
                    compo.setState({ loadingInseminations: false });
                }
                console.log("request failed, fetching data from storage");
            });
    }

    renderFilter(breedings, classes) {

        return (
            <div>
                <AppBar position="static">
                    <Tabs value={this.state.tabId} name="tabId" onChange={this.handleTabChange}>
                        <Tab label="Chovy" />
                        <Tab label="Plemennice" /> {/*Autocomplete z dotiahnutych */}
                    </Tabs>
                </AppBar>
                <Paper style={divStyle}>
                    {this.state.tabId === 0 && <TabContainer>
                        <FormControl margin="normal" fullWidth>
                            <InputLabel shrink htmlFor="breeding">Chov</InputLabel>
                            <Select
                                id="breeding"
                                name="breeding"
                                value={this.state.breeding}
                                onChange={this.handleChange}
                                input={<Input name="breeding" id="breeding" />}
                                autoWidth
                            >
                                <MenuItem value="Vyber chov">
                                    <em>Vyber chov</em>
                                </MenuItem>
                                {breedings.map(breeding =>
                                    <MenuItem key={breeding} value={breeding}>{breeding}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <FormControl margin="normal" fullWidth>
                            <TextField
                                name="dateFrom"
                                id="dateFrom"
                                label="Inseminácie Od"
                                onChange={this.handleChange.bind(this)}
                                type="date"
                                defaultValue={this.state.dateFrom}
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>
                        <FormControl margin="normal" fullWidth>
                            <TextField
                                name="dateTo"
                                id="dateTo"
                                label="Inseminácie Do"
                                onChange={this.handleChange.bind(this)}
                                type="date"
                                defaultValue={this.state.dateTo}
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>

                    </TabContainer>}
                    {this.state.tabId === 1 && <TabContainer>
                        <FormControl margin="normal" fullWidth>
                            <InputLabel shrink htmlFor="breedingPlem">Chov</InputLabel>
                            <Select
                                id="breedingPlem"
                                name="breeding"
                                value={this.state.breeding}
                                onChange={this.handleChange}
                                input={<Input name="breeding" id="breedingPlem" />}
                                autoWidth
                            >
                                <MenuItem value="Vyber chov">
                                    <em>Vyber chov</em>
                                </MenuItem>
                                {breedings.map(breeding =>
                                    <MenuItem key={breeding} value={breeding}>{breeding}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <FormControl margin="normal" fullWidth>
                            <InputLabel htmlFor="username">Ušné číslo</InputLabel>
                            <Input id="cowName" name="animalCode" value={this.state.animalCode} onChange={this.handleChange} />
                        </FormControl>

                    </TabContainer>}

                    <Button
                        onClick={() => { this.filter(); }}
                        variant="contained"
                        color="secondary"
                    >Načítaj</Button>
                </Paper >
            </div>
        );

    }
    renderInseminations(inseminations) {
        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">Zoznam inseminácií</Typography>
                    </Toolbar>
                </AppBar>
                <Paper style={divStyle} >
                    <List padding="none">
                        {inseminations && inseminations.length > 0 ? inseminations.map(insem =>
                            <ListItem divider key={insem.id + insem.dateInsem + insem.animalCode} alignItems="flex-start" >
                                <ListItemText>
                                    <FormControl margin="dense" style={minWidthFcStyle}>
                                        <InputLabel htmlFor={'calvingResult' + insem.animalCode} >Kód teľnosti</InputLabel>
                                        <Input margin="dense" inputProps={{ tag: insem.animalCode }} id={'calvingResult' + insem.animalCode} tag={insem.animalCode} name="calvingResult" value={insem.calvingResult ? insem.calvingResult : ''} onChange={this.handleCalvingResultChange} />
                                    </FormControl>
                                    <FormControl style={minWidthFcStyle}>
                                        <TextField
                                            disabled
                                            id="standard-read-only-input"
                                            label="Výsledok vyšetrenia"
                                            defaultValue={insem.exam}
                                            margin="dense"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl style={minWidthFcStyle}>
                                        <TextField
                                            disabled
                                            id="standard-read-only-input"
                                            label="Ušné čislo"
                                            defaultValue={insem.animalCode}
                                            margin="dense"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl style={minWidthFcStyle}>
                                        <TextField
                                            disabled
                                            name="insemDate"
                                            label="Dátum inseminácie"
                                            margin="dense"
                                            type="date"
                                            defaultValue={insem.dateInsem}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                </ListItemText>

                            </ListItem>)
                            :
                            <ListItem key="empty">
                                <ListItemText>Žiadne výsledky </ListItemText>
                            </ListItem>}
                    </List>
                    <Button
                        onClick={() => { this.save(); }}
                        variant="contained"
                        color="secondary"
                    >Ulož</Button>
                </Paper>
            </div>
        );
    }
    handleTabChange = (event, value) => {
        this.setState({ tabId: value });
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleCalvingResultChange = event => {
        var inseminations = this.state.inseminations;
        var animalCode = event.target.getAttribute('tag')

        inseminations.forEach(function (insem) {
            if (insem.animalCode === animalCode) {
                insem[event.target.name] = event.target.value;
            }
        });

        this.setState({ inseminations: inseminations });
    };

    renderBusyIndicator(props) {
        return (
            <Paper style={{ padding: 15 }}>
                <CircularProgress className={props.progress} />
            </Paper>
        );
    }

    render() {
        let contents = this.state.loadingInseminations
            ? this.renderBusyIndicator(this.props)
            : this.renderInseminations(this.state.inseminations, this.props);
        let filter = this.state.loading
            ? this.renderBusyIndicator(this.props)
            : this.renderFilter(this.state.breedings, this.props);

        return (
            <div>
                {filter}
                {contents}
            </div>
        );
    }
}
export default withSnackbar()(CalvingReport)


// WEBPACK FOOTER //
// ./src/components/technik/CalvingReport.jsx